import React, { createContext, useContext, useEffect, useState } from 'react';
import { isObject } from '../utils/helper';

const ParamsContext = createContext(null);
const useValueOfParamsContext = (params) => {
  const [options, setOptions] = useState(isObject(params) ? params : {});
  useEffect(() => {
    setOptions(isObject(params) ? params : {});
  }, [params]);
  return options;
};

export const useParamsContext = () => useContext(ParamsContext);
export const ParamsProvider = ({ params, children }) => {
  const value = useValueOfParamsContext(params);
  return <ParamsContext.Provider value={value}>{children}</ParamsContext.Provider>;
};
